import React from 'react'

const Error = () => {
  return (
    <div style={{width:"100%", height: "100vh",display:"flex",justifyContent:"center", alignItems:"center"}}>
      <h4>!404 Page Not Found</h4>
    </div>
  )
}

export default Error
